import { useRef } from 'react'

/**
 * Keeps the object always up to date but doesn't trigger re-render
 * @param obj
 */
export function useScope<T extends object>(obj: T): T {
  return Object.assign(useRef({} as T).current, obj)
}
